import type { ReactNode } from "react"
import { Head } from "@inertiajs/react"

import { LandingLayout } from "@/components/layouts/landing-layout"
import {
  CapabilitiesSection,
  ClosingSection,
  LandingFooter,
  LandingHeader,
  LandingHero,
  PricingSection,
  SelfServiceSection,
  ShiftSection,
  SurfacesSection,
  type LandingLinks,
} from "@/features/landing"
import { t } from "@/lib/i18n"

type LandingIndexProps = {
  links: LandingLinks
}

type LandingPageComponent = ((props: LandingIndexProps) => ReactNode) & {
  layout?: (page: ReactNode) => ReactNode
}

const LandingIndex: LandingPageComponent = ({ links }) => (
  <>
    <Head title={t("ui.landing.meta.title")}>
      <meta name="description" content={t("ui.landing.meta.description")} />
    </Head>

    <LandingHeader links={links} />

    <main id="top" className="overflow-hidden">
      <LandingHero links={links} />
      <SelfServiceSection />
      <CapabilitiesSection />
      <PricingSection links={links} />
      <ShiftSection />
      <SurfacesSection />
      <ClosingSection links={links} />
    </main>

    <LandingFooter links={links} />
  </>
)

LandingIndex.layout = (page) => <LandingLayout>{page}</LandingLayout>

export default LandingIndex
